import { render, staticRenderFns } from "./DouYin.vue?vue&type=template&id=90a701f4&scoped=true"
import script from "./DouYin.vue?vue&type=script&lang=js"
export * from "./DouYin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a701f4",
  null
  
)

export default component.exports